import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WarehousesState } from '../reducers/warehouses.reducer';
import { WAREHOUSES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<WarehousesState>(WAREHOUSES_FEATURE_KEY);

export const selectWarehouses = createSelector(selectState, (state: WarehousesState) => state.warehouses);
export const selectLoaded = createSelector(selectState, (state: WarehousesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: WarehousesState) => state.loading);
export const selectTotal = createSelector(selectState, (state: WarehousesState) => state.total);
